import { combineReducers } from 'redux'

import sign_up from './sign_up'
import sessions from './sessions'
import current from './current'
import authorization from './authorization'
import otp from './otp'
import passwords from './passwords'
import confirmations from './confirmations'
import unlocks from './unlocks'

export default combineReducers({
  sign_up,
  sessions: combineReducers({
    index: sessions
  }),
  current,
  authorization,
  otp,
  passwords,
  confirmations,
  unlocks
})



// WEBPACK FOOTER //
// ./src/modules/users/index.js